let completed_pill_filters = {
    All: {name: 'All', display: 'All', is_active: 1, is_visible: true, count: 0},
    Indeterminate: {name: 'Indeterminate', display: 'Indeterminate', is_active: 0, is_visible: true, count: 0},
    Compliant: {name: 'Compliant', display: 'Passed', is_active: 0, is_visible: true, count: 0},
    NonCompliant: {name: 'NonCompliant', display: 'Failed', is_active: 0, is_visible: true, count: 0}
}

module.exports = completed_pill_filters
